import React, { useState, useEffect, useContext } from 'react';
import { getFirestore, collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import { CartContext } from './../contexts/CartContext';
import { Link } from 'react-router-dom';
import { FavoriteContext } from './../contexts/FavoriteContext';

export default function SearchModal() {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const db = getFirestore(); // Initialize Firestore

  const { addToCart } = useContext(CartContext);
  const { favorites, addFavorite, removeFavorite } = useContext(FavoriteContext);

  useEffect(() => {
    if (searchQuery.length > 0) {
      setLoading(true);
      fetchSearchResults();
    } else {
      setSearchResults([]);
    }
  }, [searchQuery]);

  const updateProducts = async () => {
    const db = getFirestore();
    const productsCollection = collection(db, 'Products');
    const querySnapshot = await getDocs(productsCollection);
  
    for (const docSnapshot of querySnapshot.docs) {
      const productData = docSnapshot.data();
      const lowercaseName = productData.name.toLowerCase();
      await updateDoc(doc(db, 'Products', docSnapshot.id), { lowercaseName });
    }
  
    console.log('Products updated with lowercase names.');
  };
  
  updateProducts().catch(console.error);

  const fetchSearchResults = async () => {
    try {
      const lowercaseQuery = searchQuery.toLowerCase();
      const q = query(
        collection(db, 'Products'),
        where('lowercaseName', '>=', lowercaseQuery),
        where('lowercaseName', '<=', lowercaseQuery + '\uf8ff')
      );
      const querySnapshot = await getDocs(q);
      const results = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setSearchResults(results);
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddToCart = (product) => {
    const item = {
      id: product.id,
      name: product.name,
      price: product.price,
      images: product.images,
      quantity: 1,
      color: product.colors ? product.colors[0] : null,
      size: product.sizes ? product.sizes[0] : null,
    };
    addToCart(item);
  };

  const handleToggleFavorite = (product) => {
    if (favorites.some(item => item.id === product.id)) {
      removeFavorite(product.id);
    } else {
      addFavorite(product);
    }
  };

  return (
    <>
      {/* Search Modal */}
      <div className="modal fade" id="searchModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body mt-4 container" style={{overflowX: "hidden"}}>
              <form action="#" method="get">
                <input
                  type="text"
                  name="search_input"
                  autoFocus
                  className='black-bordered-input'
                  placeholder='Search...'
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </form>
              {loading && <div className="d-flex justify-content-center">
                <div class="spinner-border"></div>
              </div> }
              <div className="search-results">
                {searchResults.length > 0 ? (
                  <div className="row g-5 mt-4" style={{ display: "flex", justifyContent: "center", overflowX:'hidden' }}>
                    {searchResults.map(product => (
                      <div className="col-md-6 col-xl-4 col-sm-6 col-12 p-card-wrap p-0" key={product.id}>
                        <div className="px-3">
                          <Link to={`/p/${product.id}`} className='prod-link'>
                            <div className="p-card">
                              <div className="product-image-container">
                                <div className="card-image">
                                  <img src={product.images[0]} alt="" />
                                </div>
                              </div>
                              <div className="p-card-details mt-3 px-3">
                                <h6 className="fw-bold nunito-2">{product.name}</h6>
                                <p className='nunito-2'>₦{product.price}</p>
                              </div>
                            </div>
                          </Link>
                          <div className="d-flex justify-content-between p-3">
                              <button className="black-button d-flex align-content-center" onClick={() => handleAddToCart(product)}>
                                <span className='unbounded' style={{ fontSize: "15px" }}>Add to bag &nbsp;</span>
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg">
                                  <path fillRule="evenodd" d="M14 5H2v9a1 1 0 001 1h10a1 1 0 001-1V5zM1 4v10a2 2 0 002 2h10a2 2 0 002-2V4H1z" clipRule="evenodd" />
                                  <path d="M8 1.5A2.5 2.5 0 005.5 4h-1a3.5 3.5 0 117 0h-1A2.5 2.5 0 008 1.5z" />
                                </svg>
                              </button>
                              <button className="d-flex justify-content-center align-items-center p-2 border-0" style={{ color: 'black', cursor: 'pointer', backgroundColor: 'white', borderRadius: '50%' }} onClick={() => handleToggleFavorite(product)}>
                                {favorites.some(item => item.id === product.id) ? (
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path></svg>
                                    
                                    
                                    
                                ) : (
                                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
                                    </svg>
                                  )}
                              </button>
                            </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="d-flex justify-content-center mt-5">
                    <h1 className="unbounded text-muted">
                        No result found...
                    </h1>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
